import { motion } from "framer-motion";
import { ShieldCheck, Award, Gem, Heart, Sparkles } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { WHY_US } from "@/data/site";

const ICONS = [ShieldCheck, Award, Gem, Heart, Sparkles];

export const WhyUs = () => (
  <section id="neden-biz" className="relative py-28 lg:py-36 bg-grad-dark grain overflow-hidden" data-testid="why-us-section">
    <div className="absolute top-0 right-0 w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(230,0,126,0.25),transparent_60%)] blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionTitle light eyebrow="Neden Bizi Tercih Etmelisiniz" title={<>Güven veren bir <span className="text-gradient-light">salon deneyimi</span></>} desc="Her detayda özen: hijyenden ürün kalitesine, salon atmosferinden müşteri ilişkilerine kadar." />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
        {WHY_US.map((w, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={w.title}
              data-testid={`why-us-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -8 }}
              className="group relative rounded-3xl p-7 bg-white/[0.06] border border-white/10 backdrop-blur-md hover:bg-white/[0.1] transition-colors duration-500"
            >
              <div className="w-12 h-12 rounded-2xl bg-grad-pink flex items-center justify-center text-white shadow-[0_10px_30px_-8px_rgba(230,0,126,0.6)]">
                <Icon size={22} />
              </div>
              <p className="mt-6 text-xs tracking-[0.2em] text-pink-200/60">0{i + 1}</p>
              <h3 className="mt-2 text-lg font-semibold text-white">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-pink-100/70">{w.desc}</p>
            </motion.div>
          );
        })}
      </div>
      <Reveal delay={0.3} className="mt-16 text-center">
        <p className="text-2xl sm:text-3xl font-semibold text-gradient-light tracking-tight">"Kendinin En Güzel Hâli"</p>
      </Reveal>
    </div>
  </section>
);
